import fire from '@store/firebase';
import { CollectionPath } from '@typings/collections.enum';

const firestore = fire.firestore();
const usersRef = firestore.collection(CollectionPath.USERS);
const auth = fire.auth();

// ─── 모듈 레벨 멤버 캐시 (Recoil atom 브릿지) ───
export interface MemberItem {
  id: string;
  value: string; // displayName
  photoURL: string;
}

let _membersCache: MemberItem[] | null = null;

/** Recoil atom 동기화용 — useMembersInit 훅에서 호출 */
export function setMembersCache(members: MemberItem[]) {
  _membersCache = members;
}

/** 캐시 무효화 (멤버 변경 시 호출) */
export function invalidateMembersCache() {
  _membersCache = null;
}

/**
 * 멤버 목록 조회 — 캐시 우선, 캐시 미스 시 Firestore 조회
 * hook 외부(util 함수, Quill 모듈 등)에서도 안전하게 사용 가능
 */
export async function getMembers(): Promise<MemberItem[]> {
  if (_membersCache) return _membersCache;

  const userList = await usersRef.get().then((res) => res.docs);

  const userMap = userList.map((doc) => {
    return {
      id: doc.id,
      value: doc.data().displayName,
      photoURL: doc.data().photoURL,
    };
  });

  _membersCache = userMap;
  return userMap;
}

// 익명 유저 가져오기
export async function getAnonymousUser() {
  const uid = await auth.onAuthStateChanged((user) => {
    if (user) {
      const uid = user.uid;
      return uid;
    } else {
      // User is signed out
    }
  });

  return uid;
}
